import styles from './Thanks.module.scss'
const Thanks: React.FC = () => {
  return (
    <div className={styles.thanks_container}>
      <div className={styles.thanks_section}>
        <div className={styles.thanks_section_heading}>
          <h1>お問い合わせいただきありがとうございます。</h1>
          <p>
            コンサルタントからご連絡を差し上げます。
            <br />
            お問い合わせ内容によってはお時間をいただく場合もございますので、予めご了承ください。
          </p>
        </div>
        {/* <div className={styles.thanks_section_meeting}>
          <div className={styles.thanks_section_meeting_heading}>
            <div className={styles.thanks_section_meeting_heading_square}></div>
            <div className={styles.thanks_section_meeting_heading_wrapper}>
              <p className={styles.thanks_section_meeting_heading_wrapper_title}>お打ち合わせご希望の場合</p>
              <p className={styles.thanks_section_meeting_heading_wrapper_text}>
                下記カレンダーから、ご希望の日時をご登録ください。
              </p>
            </div>
          </div>
          <div className={styles.iframe}>
            <iframe
              src="https://meetings.hubspot.com/kodama-jun/lp?embed=true"
              title="hubspot"
              style={{
                width: '100%',
                height: '690px',
              }}
            ></iframe>
          </div>
        </div> */}
      </div>
    </div>
  )
}
export default Thanks
